import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISelectedInformation } from '../interfaces/selected-information.interface';

@Injectable({
  providedIn: 'root',
})
export class ChatPanelService {
  private isOpenSubject$ = new BehaviorSubject<boolean>(false);
  private selectedInformationSubject$ = new BehaviorSubject<ISelectedInformation | null>(null);

  getIsOpen$(): Observable<boolean> {
    return this.isOpenSubject$.asObservable();
  }

  getSelectedInformation$(): Observable<ISelectedInformation | null> {
    return this.selectedInformationSubject$.asObservable();
  }

  isOpen(): boolean {
    return this.isOpenSubject$.getValue();
  }

  open(information?: ISelectedInformation): void {
    const current = this.selectedInformationSubject$.getValue();
    if (information && (information.id !== current?.id || information.generatedAt !== current?.generatedAt)) {
      this.selectedInformationSubject$.next(information);
    }
    if (!this.isOpen()) {
      this.isOpenSubject$.next(true);
    }
  }

  close(): void {
    this.isOpenSubject$.next(false);
    this.clearSelectedInformation();
  }

  toggle(): void {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  clearSelectedInformation(): void {
    this.selectedInformationSubject$.next(null);
  }
}
